<div class="visualization-container">
  <div class="label-text">{{ label }}</div>
  <div #grid *ngIf="instructions?.length" [ngStyle]="gridStyles$ | async">
    <app-investment-instructions-card
      *ngFor="let instruction of instructions"
      [instruction]="instruction"
      [backgroundColor]="cardBackgroundColour"
      [borderColor]="cardBorderColour" />
  </div>
</div>
